module.exports = __webpack_public_path__ + "img/usdt.66f1b147.svg";